import React from 'react';
import { motion } from 'framer-motion';
import { Handshake } from 'lucide-react';
export function AboutSection() {
  return <section className="py-14 px-4 bg-navy-50" data-id="element-8">
      <div className="max-w-3xl mx-auto" data-id="element-9">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-navy-100 relative overflow-hidden" data-id="element-10">
          {/* Decorative quote mark */}
          <div className="absolute top-4 right-8 text-9xl text-navy-50 font-serif leading-none select-none pointer-events-none" data-id="element-11">
            "
          </div>

          <div className="relative z-10" data-id="element-12">
            <div className="flex items-center gap-3 text-navy-600 mb-8" data-id="element-13">
              <Handshake className="w-6 h-6" data-id="element-14" />
              <h2 className="text-sm font-bold tracking-widest uppercase" data-id="element-15">
                Quién soy y por qué confiar
              </h2>
            </div>

            <h3 className="text-3xl font-serif font-bold text-navy-900 mb-8" data-id="element-16">
              No soy un gurú. No tengo un escenario con luces de neón.
            </h3>

            <div className="space-y-6 text-lg text-navy-700 leading-relaxed" data-id="element-17">
              <p data-id="element-18">
                Soy alguien que caminó por las mismas heridas que tú — y que
                aprendió, muchas veces a golpes, a identificarlas, nombrarlas y
                sanarlas.
              </p>
              <p data-id="element-19">
                He hablado con personas que estaban a punto de rendirse
                espiritualmente. Con empresarios que tenían éxito afuera y caos
                adentro. Con gente que fumaba, gastaba, procrastinaba — no por
                vicio, sino por dolor.
              </p>

              <div className="py-6 border-y border-navy-100 my-8" data-id="element-20">
                <p className="font-serif text-2xl text-navy-900 italic" data-id="element-21">
                  Y lo que he descubierto es esto:
                </p>
                <p className="font-bold text-navy-900 mt-4 text-xl" data-id="element-22">
                  Una conversación honesta, guiada con las herramientas
                  correctas, puede hacer lo que años de esfuerzo solo no
                  pudieron.
                </p>
              </div>

              <p data-id="element-23">
                No porque sea mágico. Sino porque por primera vez, alguien te
                ve. Alguien te escucha sin agenda. Y alguien te ayuda a trazar
                el camino desde adentro hacia afuera.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}